/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CollaboratorAssessmentResponseCto } from '../models/collaborator-assessment-response-cto';
import { getByJobIdAsync$Json } from '../fn/collaborator-assessment/get-by-job-id-async-json';
import { GetByJobIdAsync$Json$Params } from '../fn/collaborator-assessment/get-by-job-id-async-json';
import { getByJobIdAsync$Plain } from '../fn/collaborator-assessment/get-by-job-id-async-plain';
import { GetByJobIdAsync$Plain$Params } from '../fn/collaborator-assessment/get-by-job-id-async-plain';

@Injectable({ providedIn: 'root' })
export class CollaboratorAssessmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getByJobIdAsync()` */
  static readonly GetByJobIdAsyncPath = '/collaborator-assessment/company/{companyGuid}/job/{jobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByJobIdAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByJobIdAsync$Plain$Response(params: GetByJobIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollaboratorAssessmentResponseCto>>> {
    return getByJobIdAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByJobIdAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByJobIdAsync$Plain(params: GetByJobIdAsync$Plain$Params, context?: HttpContext): Observable<Array<CollaboratorAssessmentResponseCto>> {
    return this.getByJobIdAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CollaboratorAssessmentResponseCto>>): Array<CollaboratorAssessmentResponseCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByJobIdAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByJobIdAsync$Json$Response(params: GetByJobIdAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollaboratorAssessmentResponseCto>>> {
    return getByJobIdAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByJobIdAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByJobIdAsync$Json(params: GetByJobIdAsync$Json$Params, context?: HttpContext): Observable<Array<CollaboratorAssessmentResponseCto>> {
    return this.getByJobIdAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CollaboratorAssessmentResponseCto>>): Array<CollaboratorAssessmentResponseCto> => r.body)
    );
  }

}
